import { render, staticRenderFns } from "./OfertasDemandas.vue?vue&type=template&id=e8585b82&scoped=true"
import script from "./OfertasDemandas.vue?vue&type=script&lang=ts"
export * from "./OfertasDemandas.vue?vue&type=script&lang=ts"
import style0 from "./OfertasDemandas.vue?vue&type=style&index=0&id=e8585b82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8585b82",
  null
  
)

export default component.exports